// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimVopSetService} from "@services";
import {from, Observable, of} from "rxjs";
import {VTPSet} from "@models";

@Pipe({
	name: "getVopSetById",
	standalone: false,
})
export class GetVopSetByIdPipe implements PipeTransform {
	constructor(private _simVopSetService: SimVopSetService) {}

	transform(vopSetId: string): Observable<VTPSet> {
		if (!vopSetId) {
			return of(null);
		}
		return from(this._simVopSetService.getVOPSetById(vopSetId));
	}
}
